import { SMART_PACKAGE_CONTRACT_ATTRIBUTE } from '@/open-web/utils/constants'

export const shouldHideBundledAddons = (productAttributes?: string[] | null): boolean => {
  return productAttributes?.includes(SMART_PACKAGE_CONTRACT_ATTRIBUTE) ?? false
}
